// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"877f15d6","120":"8f6f11cb","234":"70349ed4","237":"152d7658","264":"09d8b471","569":"e7ecb300","638":"6537e8e1","692":"09cf7b33","712":"f0f39888"}[chunkId] + ".chunk.js";
};